import { useRouteContext } from '@tanstack/react-router'

export function usePermissions(): string[] {
  const { permissions } = useRouteContext({ from: '__root__' })
  return permissions
}

export function useHasPermission(permission: string): boolean {
  const permissions = usePermissions()
  return permissions.includes(permission)
}

export function useHasAnyPermission(permissions: string[]): boolean {
  const userPermissions = usePermissions()
  return permissions.some((p) => userPermissions.includes(p))
}
